// extracted by mini-css-extract-plugin
export default {"button":"SpaceDockButton_button__aw75N"};